import { useNavigate } from "react-router-dom";
import $ from "jquery";
import { TextField } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { fetchApi } from "../../../helper/api";
import { useEffect, useState } from "react";
import { IsAlert } from "../../atoms/IsAlert";

const EditUser = (props) => {
  const navigate = useNavigate();
  const [role, setRole] = useState();
  const [roleVal, setRoleVal] = useState();
  useEffect(() => {
    getRole();
  }, []);

  const getRole = async () => {
    const req = await fetchApi("api/Role", "GET", true);
    const res = await req.json();
    setRole(res.data.response);
  };

  const handleChange = (data) => {
    setRoleVal(data);
  };

  const handleSubmit = async () => {
    const dataPost = {
      email: props.dataEdit.email,
      roleId: roleVal?.idRole,
      // desc: roleVal?.desc,
      // nameRole: roleVal?.namaRole,
    };
    const req = await fetchApi("api/Role/userRole", "PUT", true, dataPost);
    const status = req.status;
    const res = await req.json();
    $(".close").click();
    if (status !== 200) {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "error",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
        }
      });
    } else {
      IsAlert.fire({
        title: res.status,
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          props.reloadData();
        }
      });
    }
  };

  // console.log("DATA EDIT", props.dataEdit);
  // console.log("ROLE", role);

  if (props.dataEdit) {
    return (
      <div
        className="modal fade"
        id="EditUser_modal"
        tabIndex={-1}
        aria-labelledby="EditUser_modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-sm">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h5 className="mb-0 ml-2">Edit User</h5>
              </div>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form className="p-1">
                <div className="py-2">
                  <label>Email</label>
                  <h6>
                    <b>{props?.dataEdit?.email}</b>
                  </h6>
                </div>
                <div className="py-2">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Role</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      label="Role"
                      onChange={(e) => handleChange(e.target.value)}
                      defaultValue=""
                    >
                      {role?.map((e, i) => {
                        return (
                          <MenuItem key={e.idRole} value={e}>
                            {e.namaRole}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-success"
                onClick={handleSubmit}
              >
                Simpan
              </button>
              <button
                type="button"
                className="btn btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return "";
};
export default EditUser;
